import { render, staticRenderFns } from "./Previewable.vue?vue&type=template&id=aedcdc4e&"
import script from "./Previewable.vue?vue&type=script&lang=ts&"
export * from "./Previewable.vue?vue&type=script&lang=ts&"
import style0 from "./Previewable.vue?vue&type=style&index=0&id=aedcdc4e&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports